import {
  changeStyleToAllUpsellText,
  changeUpsellFontCode,
  changeUpsellFontFace,
  changeUpsellFontSize,
  changeUpsellFontSizesAndUpsellImprintFits,
  changeUpsellHeightFits,
  changeUpsellImprintAreaDimension,
  changeUpsellScale,
  changeUpsellText,
  changeUpsellTextStyle,
  initializeUpsells,
  selectUpsellText,
  toggleOptionalUpsellSelectedStatus,
  toggleRequiredUpsellSelectedStatus,
  unSelectAllUpsellText,
  updateUpellFullPreviewUrl,
  updateUpsellQuantity,
} from './actions';

import { createReducer } from '@reduxjs/toolkit';
import { elementStatus } from '../utils/constants';

const getUpsellTextElement = function (upsellTextDict, imprintAreaKey, guid) {
  const upsellTextList = upsellTextDict[imprintAreaKey];
  return upsellTextList.find((e) => e.ui.guid === guid);
};

export const upsells = createReducer([], (builder) => {
  builder
    .addCase(initializeUpsells, (state, action) => {
      state.length = 0;
      for (let upsell of action.payload) {
        let newUpsell = {
          isSelected: upsell.isSelected,
          item: upsell.item,
          price: upsell.price,
          totalQuantity: upsell.totalQuantity,
          bomPreview: upsell.bomPreview,
          matchedQuestionCodeForUpsell: upsell.matchedQuestionCodeForUpsell,
          hasBomOptions: upsell.hasBomOptions,
          colorQuestionCodes: upsell.colorQuestionCodes,
          textDict: upsell.text,
          imageDict: upsell.image,
          fontDict: upsell.font,
          fontSizeRangeDict: upsell.fontSizeRange,
          imprintAreaDimension: upsell.imprintAreaDimension,
          imprintAreas: upsell.imprintAreas,
          logoLocationCode: upsell.logoLocationCode,
          imprintLocationCode: upsell.imprintLocationCode,
          previewUrl: upsell.previewUrl,
          childOptions: upsell.childQuestionOptions,
          questions: upsell.questions,
          relations: upsell.questionRelations,
          uniqueOptions: upsell.questionUniqueOptions,
          heightFits: {},
          scaleDict: {},
          fullPreviewUrl: '',
        };
        state.push(newUpsell);
      }
    })
    .addCase(updateUpsellQuantity, (state, action) => {
      const itemId = action.payload.itemId;
      const quantity = action.payload.quantity;
      let upsellItem = state.find((upsell) => upsell.item.itemId === itemId);
      if (upsellItem) {
        upsellItem.totalQuantity = quantity;
      }
    })
    .addCase(toggleRequiredUpsellSelectedStatus, (state, action) => {
      const { itemId } = action.payload;
      state
        .filter((upsell) => upsell && upsell.item && upsell.item.isRequired)
        .forEach((upsell) => {
          const isSelected = upsell.item.itemId === itemId;
          upsell.isSelected = isSelected;
          if (!isSelected) upsell.totalQuantity = 0;
        });
    })
    .addCase(toggleOptionalUpsellSelectedStatus, (state, action) => {
      const { itemId, isSelected } = action.payload;
      const target = state
        .filter((upsell) => upsell && upsell.item && !upsell.item.isRequired)
        .find((upsell) => upsell.item.itemId && upsell.item.itemId === itemId);
      if (target) {
        target.isSelected = isSelected;
        if (!isSelected) target.totalQuantity = 0;
      }
    })
    .addCase(changeUpsellScale, (state, action) => {
      const upsellItemId = action.payload.upsellItemId;
      const upsellImprintAreaKey = action.payload.upsellImprintAreaKey;
      const upsellScale = action.payload.upsellScale;
      let upsellItem = state.find((upsell) => upsell.item.itemId === upsellItemId);
      if (upsellItem) {
        upsellItem.scaleDict[upsellImprintAreaKey] = upsellScale;
      }
    })
    .addCase(changeUpsellImprintAreaDimension, (state, action) => {
      const upsellItemId = action.payload.upsellItemId;
      const upsellImprintAreaKey = action.payload.upsellImprintAreaKey;
      const upsellImprintAreaDimension = action.payload.upsellImprintAreaDimension;
      let upsellItem = state.find((upsell) => upsell.item.itemId === upsellItemId);
      if (upsellItem) {
        upsellItem.imprintAreaDimension[upsellImprintAreaKey] = upsellImprintAreaDimension;
      }
    })
    .addCase(changeUpsellFontSizesAndUpsellImprintFits, (state, action) => {
      const upsellItemId = action.payload.upsellItemId;
      const upsellImprintAreaKey = action.payload.upsellImprintAreaKey;
      const upsellFontSizes = action.payload.upsellFontSizes;
      const upsellImprintFits = action.payload.upsellImprintFits;
      let upsellItem = state.find((upsell) => upsell.item.itemId === upsellItemId);
      if (upsellItem) {
        upsellItem.textDict[upsellImprintAreaKey].forEach((text, index) => {
          if (upsellFontSizes) {
            text.data.fontSize = upsellFontSizes[index];
            text.data.imprintFits = upsellImprintFits[index];
          }
        });
      }
    })
    .addCase(changeUpsellHeightFits, (state, action) => {
      const upsellItemId = action.payload.upsellItemId;
      const upsellImprintAreaKey = action.payload.upsellImprintAreaKey;
      const upsellHeightFits = action.payload.upsellHeightFits;
      let upsellItem = state.find((upsell) => upsell.item.itemId === upsellItemId);
      if (upsellItem) {
        upsellItem.heightFits[upsellImprintAreaKey] = upsellHeightFits;
      }
    })
    .addCase(changeUpsellFontFace, (state, action) => {
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        let upsellTextElement = getUpsellTextElement(
          upsellItem.textDict,
          action.payload.upsellImprintAreaKey,
          action.payload.guid
        );
        if (upsellTextElement) {
          upsellTextElement.data.fontFace = action.payload.fontFace;
          upsellTextElement.data.isBold = action.payload.isBold;
          upsellTextElement.data.isItalic = action.payload.isItalic;
        }
      }
    })
    .addCase(changeUpsellFontCode, (state, action) => {
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        let upsellTextElement = getUpsellTextElement(
          upsellItem.textDict,
          action.payload.upsellImprintAreaKey,
          action.payload.guid
        );
        if (upsellTextElement) {
          upsellTextElement.data.fontCode = action.payload.selectedFontCode;
        }
      }
    })
    .addCase(changeUpsellTextStyle, (state, action) => {
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        let upsellTextElement = getUpsellTextElement(
          upsellItem.textDict,
          action.payload.upsellImprintAreaKey,
          action.payload.guid
        );
        if (upsellTextElement) {
          upsellTextElement.data.isBold = action.payload.increment.data.isBold;
          upsellTextElement.data.isItalic = action.payload.increment.data.isItalic;
        }
      }
    })
    .addCase(changeUpsellFontSize, (state, action) => {
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        let upsellTextElement = getUpsellTextElement(
          upsellItem.textDict,
          action.payload.upsellImprintAreaKey,
          action.payload.guid
        );
        if (upsellTextElement) {
          upsellTextElement.data.fontSizeText = action.payload.fontSizeText;
        }
      }
    })
    .addCase(changeUpsellText, (state, action) => {
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        let upsellTextElement = getUpsellTextElement(
          upsellItem.textDict,
          action.payload.upsellImprintAreaKey,
          action.payload.guid
        );
        if (upsellTextElement) {
          upsellTextElement.data.imprintText = action.payload.imprintText;
        }
      }
    })
    .addCase(changeStyleToAllUpsellText, (state, action) => {
      const guids = action.payload.guids;
      const fontFace = action.payload.increment.data.fontFace;
      const fontCode = action.payload.increment.data.fontCode;
      const fontSizeText = action.payload.increment.data.fontSizeText;
      const isBold = action.payload.increment.data.isBold;
      const isItalic = action.payload.increment.data.isItalic;
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        let upsellTextElements = guids.map((guid) =>
          getUpsellTextElement(upsellItem.textDict, action.payload.upsellImprintAreaKey, guid)
        );
        if (upsellTextElements) {
          upsellTextElements.forEach((upsellTextElement) => {
            upsellTextElement.data.fontFace = fontFace;
            upsellTextElement.data.fontCode = fontCode;
            upsellTextElement.data.fontSizeText = fontSizeText;
            upsellTextElement.data.isBold = isBold;
            upsellTextElement.data.isItalic = isItalic;
          });
        }
      }
    })
    .addCase(selectUpsellText, (state, action) => {
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        let upsellTextElement = getUpsellTextElement(
          upsellItem.textDict,
          action.payload.upsellImprintAreaKey,
          action.payload.guid
        );
        if (upsellTextElement) {
          upsellTextElement.ui.status = elementStatus.SingleSelected;
        }
      }
    })
    .addCase(unSelectAllUpsellText, (state, action) => {
      const upsellItemId = action.payload.upsellItemId;
      const upsellImprintAreaKey = action.payload.upsellImprintAreaKey;
      let upsellItem = state.find((upsell) => upsell.item.itemId === upsellItemId);
      if (upsellItem) {
        const textElementList = upsellItem.textDict[upsellImprintAreaKey];
        textElementList.forEach((text) => {
          text.ui.status = elementStatus.Unselected;
        });
      }
    })
    .addCase(updateUpellFullPreviewUrl, (state, action) => {
      let upsellItem = state.find((upsell) => upsell.item.itemId === action.payload.upsellItemId);
      if (upsellItem) {
        upsellItem.fullPreviewUrl = action.payload.fullPreviewUrl;
      }
    });
});
